import React, {  useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react'; 
import 'swiper/css'; 
import './slider.css';
import image8 from '../assets/images/sliderimage/moil.webp';
import image1 from '../assets/images/sliderimage/webyazilim.webp';
import image2 from '../assets/images/sliderimage/ecommerce.webp';
import image3 from '../assets/images/sliderimage/seo.webp';
import image4 from '../assets/images/sliderimage/ui.webp';
import image5 from '../assets/images/sliderimage/clouud.webp';
import image6 from '../assets/images/sliderimage/Optimizing-API-Management.png';
import image7 from '../assets/images/sliderimage/teknik.webp';
import { useTranslation } from 'react-i18next';
import { Autoplay } from 'swiper/modules';

const SwiperSlider = () => {
  const { t } = useTranslation();

  const [swiperInstance, setSwiperInstance] = useState(null);

  const services = [
    t('mobilyazilim'),
    t('weyazilim'),
    t('eticaret'),
    t('seo'),
    t('Ui'),
    t('bulut'),
    t('api2'),
    t('bakim'),
  ];

  const titles = [
    t('mobilyazilimdesc'),
    t('webdesc'),
    t('eticaretdesc'),
    t('seodesc'),
    t('uidesc'),
    t('bulutdesc'),
    t('apidesc'),
    t('bakimdesc'),
  ];

  const images = [
    image8,
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
  ];


  const goToNextSlide = () => {
    if (swiperInstance) {
      swiperInstance.slideNext();
    }
  };


  const goToPrevSlide = () => {
    if (swiperInstance) {
      swiperInstance.slidePrev();
    }
  };

  return (
    <div className="slider-wrapper overflow-hidden p-4 md:p-6 bg-[#1f1f2c]">
      <h2 className="slider-title font-aventa"aria-label={t('ourservices')}>{t('ourservices')}</h2>
      
      <Swiper
        slidesPerView={5}
        spaceBetween={20}
        loop={true}
        freeMode={true}
        modules={[Autoplay]}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        speed={600}
        navigation={false} 
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 4,
          },
        }}
        className="mySwiper px-10"
        onSwiper={(swiper) => setSwiperInstance(swiper)} 
      >
        {services.map((service, index) => (
          <SwiperSlide key={index} className={`p-1 md:p-1 my-4`} >
            <div className="card min-h-[400px] ">
              <div className="image-wrapper">
                <img
                  src={images[index % images.length]}
                  alt={service}
                  className="card-image"
                />
              </div>
              <h4 className='font-aventa'aria-label="seo">{service}</h4>
              <p className=''>{titles[index]}</p>
            </div>
          </SwiperSlide>
        ))}

      
        {/* <div
          className="swiper-button-next -mr-1"
          onClick={goToNextSlide} 
        ></div>
        <div
          className="swiper-button-prev"
          onClick={goToPrevSlide}
        ></div> */}
      </Swiper>
    </div>
  );
};

export default SwiperSlider;
